import { Select, Option } from 'element-ui'
import HttpFactory from '@/mixins/http.factory';
export default {
	name:'configure',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			workspaceList:[],workspace:null,
			projectsList:[],project:null,asanaMapList:[],
			configData:{fieldMapping:[],hdFields:[],asanaFields:[],asanaMapList:[],zendeskMapList:[]},
            fieldsMapping:[]
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			modalClient.on('send_data_to_modal', async (data) => {
				parentClient = modalClient.instance(data.parentClientGuid)
				_self.zendeskInfo=data;
				await _self.initAsana();
			});
		},
		async getConfigData(){
			let _self=this;
			_self.fn().clearMessage();
			_self.fn().showLoader(true);
			let url =`configData/get/${_self.workspace}/${_self.project}`;
			let data={auth:_self.zendeskInfo.credentials};
			let response=await _self.post(url,data);
			_self.fn().showLoader(false);
			let configData=response.data.Data;
			configData.zendeskMapList=configData.hdFields.filter(d=>d.removable);//.filter(d=>d.type && d.type.indexOf('custom')>=0);
			configData.zendeskMapList=configData.zendeskMapList.filter(d=>d.type=='text' || d.type=='textarea' || d.type=='integer');

			//only text or strig type
			//configData.asanaMapList=configData.asanaFields.value.filter(d=>d.referenceName && d.referenceName.indexOf('Custom')>=0);
			//configData.asanaMapList=configData.asanaMapList.filter(d=>d.type=='integer' || d.type=='string' || d.type=='html');
			
			
			_self.configData=configData;
			let fieldsMapping=response.data.Data.fieldsMapping;
			if(!fieldsMapping){
				fieldsMapping={
					hdFieldName:'',
					hdFieldMappingId:'',
					asanaFieldName:'',
					asanaFieldMappingId:'',
				}

				let defaultZdField=configData.hdFields.find(d=>d.title=="Zendesk Ticket #");
				fieldsMapping.hdFieldName=defaultZdField?defaultZdField.id:'';

				let defaultDevField=configData.asanaFields.value.find(d=>d.name=="Task #");
				fieldsMapping.asanaFieldName=defaultDevField?defaultDevField.referenceName:'';
			}
			_self.fieldsMapping=fieldsMapping;
			
		},
		//starts
		async initAsana(){
			const _self=this;
			_self.workspacesFn(async function(workspaceResp){
				let workspaceList=workspaceResp.data.Data;
				if(workspaceList.length<=0){
					_self.fn().showLoader(false);
					return;
				}
				_self.workspaceList=workspaceList;
				_self.workspace=workspaceList[0].gid;
				_self.projectsFn(_self.workspace,async function(projectResp){
					let projectsList=projectResp.data.Data;
					if(projectsList.length<=0){
						_self.fn().showLoader(false);
						return;
					}
					_self.projectsList=projectsList;
					_self.project=projectsList[0].gid;
					_self.asanaFieldsFn();
				});
			},function(err){
				_self.fn().showLoader(false);
				let erroList=[
					'We see your authentication token for the Asana does not have required permissions.',
					'Can you please create Asana token as per below article and update the app.',
					'https://support.devopsintegration.io/support/solutions/articles/82000555961-how-to-create-asana-authentication-token-'
				]
				_self.userMsg={show:true,type:'danger',list:erroList};
			});
		},
		asanaFieldsFn:function(){
			const _self=this;
			_self.asanaFieldsDataFn(_self.project,async function(fieldsResp){
				let asanaMapList=fieldsResp.data.Data.customFields;
				if(asanaMapList.length<=0){
					_self.fn().showLoader(false);
					return;
				}
				//asanaMapList=asanaFields.filter(d=>d.referenceName && d.referenceName.indexOf('Custom')>=0);
				asanaMapList=asanaMapList.filter(d=>d.type=='number' || d.type=='text');
				_self.asanaMapList=asanaMapList;
				//_self.fn().showLoader(false);
				await _self.getConfigData();
			});
		},
		workspacesFn:function(successCb,errorCb){
            const _self=this;
			var url = `asana/workspaces`;
			_self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);

        },
		projectsFn:function(workspace,successCb,errorCb){
            const _self=this;
            var url = `asana/projects/${workspace}`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
		asanaFieldsDataFn:function(project,successCb,errorCb){
            const _self=this;
            var url = `asana/project/${project}`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
		postServerFn(url,data,successCb,errorCb){
			const _self=this;
			data=data?data:{};
			data.auth=_self.zendeskInfo.credentials;
			_self.post(url,data).then(response=>{
				if(successCb) successCb(response);
			}).catch(error=>{
				if(errorCb) errorCb(error);
			});
		},
		//ends
		handleFieldType:function(fieldMappingId,type){
			let _self=this;
			if(type=='asana'){
				//let field=_self.configData.asanaFields.value.find(d=>d.referenceName==fieldMappingId);
				let field=_self.asanaMapList.find(d=>d.gid==fieldMappingId);
				if(field){
					_self.fieldsMapping.asanaFieldType=field.type;
				}
			}
			if(type=='zendesk'){
				let field=_self.configData.hdFields.find(d=>d.id==fieldMappingId);
				if(field){
					_self.fieldsMapping.hdFieldType=field.type;
				}
			}
		},
		saveConfigDataFn(){
			let _self=this;
			_self.fn().clearMessage();
			let url=`fieldsmapping/saveupdate/${_self.workspace}/${_self.project}`;
			_self.handleFieldType(_self.fieldsMapping.hdFieldMappingId,'asana')
			_self.handleFieldType(_self.fieldsMapping.devOpsFieldMappingId,'zendesk');
			let data=_self.fieldsMapping;
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			_self.fn().showLoader(true);
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				let data=response.data.Data;
				if(response.data.Success){
					let userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Config data saved Successfully`]}
					_self.userMsg=userMsg;
				}
				//_self.sendDataToParent(response.data);
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		getFieldsmapping(){
			let _self=this;
			let url=`fieldsmapping/get`;
			let data={auth:_self.zendeskInfo.credentials};
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				let fieldsMapping=response.data.Data;
				_self.fieldsMapping=fieldsMapping;
			}).catch(error=>{
				_self.commonErrorMsgDisp(error);
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');

		}
	},
	components:{[Select.name]: Select,[Option.name]: Option}
}

